import React from "react";
import { motion } from "framer-motion";

const AbstractSection = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.2 },
        },
    };

    const fadeUpVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
    };

    return (
        <section className="w-full bg-white py-12 sm:py-16 md:py-20 lg:py-24 px-5 sm:px-10 lg:px-[80px] text-left relative z-10 font-sans overflow-hidden">
            <div className="max-w-[1440px] mx-auto w-full grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">

                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    className="lg:col-span-7 flex flex-col gap-5 sm:gap-6 min-w-0"
                >
                    <motion.h2
                        variants={fadeUpVariants}
                        className="text-[20px] md:text-[30px] font-[600] font-sora text-[#01386A] leading-tight tracking-tight"
                    >
                        Abstract
                    </motion.h2>

                    <motion.div
                        variants={fadeUpVariants}
                        className="text-[14px] sm:text-[16px] text-[#49577A] font-[500] font-graphik leading-relaxed space-y-5 break-words"
                    >
                        <p>
                            Enterprise AI agents are rapidly moving beyond simple task automation to become autonomous systems that can make decisions, access enterprise data, and operate across digital environments.
                        </p>
                        <p>
                            This shift opens up new possibilities for efficiency and innovation—but also introduces governance, identity, and security challenges that traditional IAM models were never equipped to handle. This whitepaper explores the emerging risks with agentic AI, including permission creep, identity misuse, memory poisoning and gaps in accountability. Built on OWASP's GenAI Security framework, Tech Mahindra and Microsoft present a practical approach to adaptive trust and AI governance.
                        </p>
                        <p>
                            It highlights technologies such as Entra Agent ID, Purview, Defender, Orion, and VerifAI, and outlines actionable strategies to build AI ecosystems that are scalable, auditable, resilient, and secure—enabling organizations to innovate with confidence.
                        </p>
                    </motion.div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, scale: 0.97, y: 20 }}
                    whileInView={{ opacity: 1, scale: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
                    className="lg:col-span-5 w-full bg-white border border-[#01386A45] border-b-4 border-b-[#01386A] p-6 sm:p-10 md:p-12 min-h-[320px] sm:min-h-[380px] flex flex-col justify-between items-start shrink-0"
                >
                    <h3 className="text-[16px] md:text-[20px] font-[600] font-sora text-[#01386A] leading-[1.3] tracking-tight w-full break-words">
                        Securing Enterprise AI Agents with Adaptive Identity Governance
                    </h3>

                    <a
                        href="#download"
                        className="inline-flex items-center gap-2 text-[14px] sm:text-[16px] font-[500] font-graphik text-[#01386A] border-b-2 border-[#01386A] pb-1 hover:text-[#ED6800] hover:border-[#ED6800] transition-colors duration-300 group outline-none select-none shrink-0"
                    >
                        <span>Download Whitepaper</span>
                        <span className="transition-transform duration-300 group-hover:translate-x-1.5 text-[16px]">&gt;</span>
                    </a>
                </motion.div>

            </div>
        </section>
    );
};

export default AbstractSection;